import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";

@Component({
  standalone: true,
  selector: "app-prefix-vgp",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-vgp.component.html",
  styleUrl: "./prefix-vgp.component.less",
})
export class PrefixVgpComponent extends PrefixTextComponent {
  public constructor() {
    super();
    this.hide = true;
    this.post = false;
    this.characters = ALLOWED_CHARACTERS["vgp"];
  }
}
